import React from 'react';
import PropTypes from 'prop-types';
import Box from '@mui/material/Box';
import Drawer from '@mui/material/Drawer';

const ActionsDrawer = ({
  actions,
  open,
  setOpen,
  title,
  subtitle,
  headerTooltipText,
  headerComponent: HeaderComponent,
  contentComponent: ContentComponent,
  width,
  loading,
  children,
  titleColor,
  paperSx,
  className,
  ...props }) => (
    <Drawer
      open={open}
      onClose={() => setOpen(false)}
      anchor="right"
      className={className}
      PaperProps={{
        sx: {
          width,
          ...paperSx,
        },
      }}
    >
      <Box
        sx={{ padding: 5, width: '100%', height: '100%', backgroundColor: 'white' }}
      >
        <HeaderComponent
          subtitle={subtitle}
          title={title}
          headerTooltipText={headerTooltipText}
          loading={loading}
          titleColor={titleColor}
        />
        {ContentComponent ? (
          <ContentComponent actions={actions} {...props} open={open} loading={loading} />
        ) : children}
      </Box>
    </Drawer>
);

ActionsDrawer.propTypes = {
  title: PropTypes.string,
  subtitle: PropTypes.string,
  headerTooltipText: PropTypes.string,
  actions: PropTypes.arrayOf(PropTypes.shape({
    id: PropTypes.string.isRequired,
    actionType: PropTypes.string,
    label: PropTypes.string,
    onClick: PropTypes.func,
  })),
  open: PropTypes.bool.isRequired,
  setOpen: PropTypes.func.isRequired,
  headerComponent: PropTypes.func,
  contentComponent: PropTypes.func,
  width: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  loading: PropTypes.bool,
  children: PropTypes.node,
  titleColor: PropTypes.string,
  paperSx: PropTypes.shape({}),
  className: PropTypes.string,
};

ActionsDrawer.defaultProps = {
  actions: [],
  title: '',
  loading: false,
  headerComponent: null,
  contentComponent: null,
  subtitle: '',
  headerTooltipText: null,
  width: 600,
  children: null,
  titleColor: 'text.highlight',
  paperSx: {},
  className: undefined,
};

export default ActionsDrawer;
